import { useMutation, useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type GetFeedbackResponse = {
  id: string
  dateCreated: string
  title: string
  content: string
  url: string
  owner: {
    ownerId: string
    name: string
    email: string
  }
}

const useGetFeedback = () => {
  return useQuery({
    queryKey: ['feedback-list'],
    queryFn: async () => {
      const { data } = await apiClient.get<GetFeedbackResponse[]>('/int/v3/platform/feedback/')
      return data
    },
  })
}

type PostFeedbackBody = {
  title: string
  content: string
}

type PostFeedbackResponse = {
  id: string
}

const usePostFeedback = () => {
  return useMutation({
    mutationFn: async (params: PostFeedbackBody) => {
      const { data } = await apiClient.post<PostFeedbackResponse>('/int/v3/platform/feedback/', params)
      return data
    },
  })
}

export const feedback = {
  getFeedback: useGetFeedback,
  postFeedback: usePostFeedback,
}
